export const SUBMIT_API = 'submitapi';
export const SEPA_API = 'sepaapi';
export const CONTRACT_SUBMIT_API = 'contractpageapi';

export const PAGE_NAME = {
    APPLY_PAGE: 'applypage',
    SEPA_PAGE: 'sepapage',
    CONTRACT_PAGE: 'contractpage',
    ERROR_PAGE: 'errorpage',
    DECISION_PAGE: 'decisionpage',
    REPAYMENT_PAGE: 'repaymentpage',
    PERSONAL_INFO_PAGE: 'personalinfopage',
    TERMS_PAGE: 'termspage',
    CYCO_PAGE: 'cycopage'
};

export const REDIRECT_SUFFIX = {
    CANCEL_REDIRECT: 'cancelFlow',
};

export const APPLICATION_STATUS = {
    NEED_SIGNATURE: 'NEED_SIGNATURE',
    VIEW_SEPA: 'VIEW_SEPA',
    APPROVED: 'APPROVED',
    SOFT_DECLINE: 'SOFT_DECLINED',
    ANS_SOFT_DECLINE: 'ppc_address_normalization_error'
};

export const CREDIT_CHECK_URL = 'https://www.paypal.com/de/webapps/mpp/ua/creditchk?locale.x=';
export const PRIVACY_POLICY_URL = 'https://www.paypal.com/de/webapps/mpp/ua/privacy-full?locale.x=';
export const LEGAL_URL = 'https://www.paypal.com/de/webapps/mpp/imprint?locale.x=';
export const DE_PRIVACY_POLICY_URL = 'https://www.paypal.com/de/webapps/mpp/ua/privacy-full?';
export const DE_CREDIT_CHECK_URL = 'https://www.paypal.com/de/webapps/mpp/ua/creditchk?';

export const FIXED_APR = '0.00';
